module.exports = __webpack_public_path__ + "static/dog-orange-background-f2afc9adb1ccc369847ddd430b2bcbc5.webp";